(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-4"]) return;
  try {
    

$(document).ready(function($) {

  function setSizes() {  	

      if ($('.as4-img').length) {
       $img = $('.as4-img').innerHeight();
        $pad = parseInt($('.as4-img').prev().css('paddingTop'));
        $('.as4-img').prev().css('paddingBottom', $img/2 + $pad);      
        $('.as4-img').next().css('paddingTop', $img/2 + $pad);
        $('.as4-img').css({"marginTop": -0.5 * $img ,"marginBottom": -0.5 * $img });

      }
  }

  setSizes();

  $(window).resize(function($){

    setSizes();  
  });


  $('.about-section-nl').parent().addClass('collection-nl-wrapper');
});


  } catch(e) { console.error(e); }
})();
})();
